import PropTypes from 'prop-types';

// PropTypes for dropdown menu HOC props
export const dropDownMenuHOCProps = {
  dropDownMenuItems: PropTypes.array,
  dropDownMenuPosition: PropTypes.string,
  dropDownMenuOffsetX: PropTypes.number,
};

// Placeholder HOC - not fully implemented
export default function withDropDownMenu(Component) {
  return Component;
}
